import { render, staticRenderFns } from "./Innovation.vue?vue&type=template&id=15f405e1&scoped=true&"
import script from "./Innovation.vue?vue&type=script&lang=js&"
export * from "./Innovation.vue?vue&type=script&lang=js&"
import style0 from "./Innovation.vue?vue&type=style&index=0&id=15f405e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f405e1",
  null
  
)

export default component.exports